import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Box} from 'views/components';

import {Translate, translate, CaregiverAutocomplete} from 'views/module';

const AddCaregiver = (props) => {
  const [caregiver, setCaregiver] = React.useState(null);

  const onClose = props.onClose;
  const addCaregiver = props.addCaregiver;

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression='client.ClientDetail.CaregiverConnections.AddCaregiver.Title' />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            p: 1,
          }}
        >
          <CaregiverAutocomplete
            label={translate('client.ClientDetail.CaregiverConnections.AddCaregiver.CaregiverSearch')}
            selectedCaregiver={caregiver}
            setSelectedCaregiver={setCaregiver}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" variant="contained" onClick={() => addCaregiver(caregiver.caregiverRn)}>
          <Translate expression='client.ClientDetail.CaregiverConnections.AddCaregiver.AddCaregiver' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddCaregiver.propTypes = {
  onClose: PropTypes.func.isRequired,
  addCaregiver: PropTypes.func.isRequired,
};

export default React.memo(AddCaregiver);
